const ilYa = (minutes) => new Date(Date.now() - minutes * 60000).toISOString();

let notifications = [
  { id: "n1", module: "dossiers", module_label: "Dossiers", data: { evenement: "fichier_ajoute", titre: "Nouveau fichier ajouté", message: "Un fichier a été ajouté au dossier CACOMC-2026-0123.", objet_type: "dossier", objet_id: 123, reference: "CACOMC-2026-0123", lien: "/dossiers/123" }, lue: false, read_at: null, created_at: ilYa(5) },
  { id: "n2", module: "audiences", module_label: "Audiences", data: { evenement: "audience_programmee", titre: "Audience programmée", message: "Le dossier CACOMC-2026-0118 est enrôlé pour le 12/11/2026.", objet_type: "dossier", objet_id: 118, reference: "CACOMC-2026-0118", lien: "/dossiers/118" }, lue: false, read_at: null, created_at: ilYa(45) },
  { id: "n3", module: "dossiers", module_label: "Dossiers", data: { evenement: "memoire_depose", titre: "Mémoire déposé", message: "Un mémoire a été déposé dans le dossier CACOMC-2026-0097.", objet_type: "dossier", objet_id: 97, reference: "CACOMC-2026-0097", lien: "/dossiers/97" }, lue: false, read_at: null, created_at: ilYa(180) },
  { id: "n4", module: "paiements", module_label: "Paiements", data: { evenement: "paiement_confirme", titre: "Paiement confirmé", message: "Votre paiement a bien été reçu.", objet_type: "paiement", objet_id: 58, reference: "PAY-0058", lien: "/paiements/58" }, lue: true, read_at: ilYa(600), created_at: ilYa(720) },
  { id: "n5", module: "dossiers", module_label: "Dossiers", data: { evenement: "dossier_mis_a_jour", titre: "Dossier mis à jour", message: "Le statut du dossier CACOMC-2026-0081 a changé.", objet_type: "dossier", objet_id: 81, reference: "CACOMC-2026-0081", lien: "/dossiers/81" }, lue: true, read_at: ilYa(1500), created_at: ilYa(2000) },
  { id: "n6", module: "audiences", module_label: "Audiences", data: { evenement: "audience_renvoyee", titre: "Audience renvoyée", message: "L'audience du dossier CACOMC-2026-0064 est renvoyée au 19/11/2026.", objet_type: "dossier", objet_id: 64, reference: "CACOMC-2026-0064", lien: "/dossiers/64" }, lue: false, read_at: null, created_at: ilYa(3000) },
];

// Simule une réponse axios avec l'enveloppe { status, message, data } de l'API
const reponse = (data) =>
  new Promise((resolve) =>
    setTimeout(() => resolve({ data: { status: true, message: "Succès !", data } }), 300)
  );

const notificationsMock = {
  index(page = 1, perPage = 5) {
    const debut = (page - 1) * perPage;
    const total = notifications.length;
    return reponse({
      current_page: page,
      data: notifications.slice(debut, debut + perPage),
      last_page: Math.max(1, Math.ceil(total / perPage)),
      per_page: perPage,
      total,
    });
  },
    unreadCount() {
    const nonLues = notifications.filter((n) => !n.lue);
    const par_module = nonLues.reduce((acc, n) => {
      acc[n.module] = (acc[n.module] || 0) + 1;
      return acc;
    }, {});
    return reponse({ total: nonLues.length, par_module });
  },
  markAsRead(id) {
    notifications = notifications.map((n) =>
      n.id === id ? { ...n, lue: true, read_at: new Date().toISOString() } : n
    );
    return reponse(null);
  },
  markAllAsRead() {
    const maintenant = new Date().toISOString();
    notifications = notifications.map((n) => (n.lue ? n : { ...n, lue: true, read_at: maintenant }));
    return reponse(null);
  },
};

export default notificationsMock;